import { createContext } from 'react'

/**
 * Deterministic figure number, computed by ReportRenderer from block order.
 * Lives in its own module so FigureFrame.tsx can export only components
 * (react-refresh/only-export-components).
 */
export const FigureNumberContext = createContext<number | null>(null)
